export default "__VITE_ASSET__Bri0iVBH__"